module.exports = __webpack_public_path__ + "img/News_item_11.31121a44.jpg";